import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type StateService from 'garaje/services/state';
import type { AtlasConfig, AtlasDisplay } from 'garaje/utils/atlas';

interface AtlasEditorPreviewComponentProps {
  display: AtlasDisplay;
  config: AtlasConfig;
}

export default class AtlasEditorPreviewComponent extends Component<AtlasEditorPreviewComponentProps> {
  @service declare state: StateService;

  @tracked iframe?: HTMLIFrameElement;

  get previewUrl(): string {
    const hostname = window.location.hostname;
    const extension = hostname.substring(hostname.lastIndexOf('.'));
    const base = `https://maps.envoy${extension}/preview`;
    const params = new URLSearchParams({
      locationId: this.state.currentLocation.id,
    });
    return `${base}?${params.toString()}`;
  }

  stringify(obj: AtlasConfig): string {
    return JSON.stringify(obj);
  }

  @action
  setupIframe(element: HTMLIFrameElement): void {
    this.iframe = element;
    element.src = this.previewUrl;

    window.addEventListener(
      'message',
      (e?: { data?: { pageLoaded?: boolean } }) => {
        if (e?.data?.pageLoaded) {
          this.pushConfig();
        }
      },
      false,
    );
  }

  @action
  pushConfig(): void {
    if (!this.iframe || !this.iframe.contentWindow) {
      return;
    }

    this.iframe.contentWindow.postMessage({ config: JSON.stringify(this.args.config) }, '*');
  }
}
